import React from 'react';

import BooleanIcon from '../../elements/booleanIcon';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function PaymentMethodDetails({ paymentMethod }) {
    return (
        <Card title="Payment Method details">
            <TableDetailsBody>
                <Row label="Name">{paymentMethod.name}</Row>
                <Row label="Slug">{paymentMethod.slug}</Row>
                <Row label="Currency">{paymentMethod.transaction_currency}</Row>
                <Row label="User fixed fee" showIf={!!paymentMethod.user_fixed_fee}>
                    {paymentMethod.user_fixed_fee} {paymentMethod.user_fixed_fee_currency}
                </Row>
                <Row label="User percent fee">{paymentMethod.user_percent_fee}</Row>
                <Row label="System fixed fee" showIf={!!paymentMethod.system_fixed_fee}>
                    {paymentMethod.system_fixed_fee} {paymentMethod.system_fixed_fee_currency}
                </Row>
                <Row label="System percent fee">{paymentMethod.system_percent_fee}</Row>
                <Row label="Is web">
                    <BooleanIcon value={paymentMethod.is_web} />
                </Row>
                <Row label="Is mobile">
                    <BooleanIcon value={paymentMethod.is_mobile} />
                </Row>
                <Row label="Is disabled">
                    <BooleanIcon value={paymentMethod.is_disabled} />
                </Row>
                <Row label="Maximum deposit amount">{paymentMethod.max_payment}</Row>
                <Row label="Minimum  deposit amount">{paymentMethod.min_payment}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default PaymentMethodDetails;
